import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert } from "react-bootstrap";
import genStyles from "styles/General.module.scss";

export const passwordRequirements = () => {
  return (
    <div>
      Passwords must contain:
      <ul>
        <li>between 10 and 20 characters</li>
        <li>at least 1 uppercase letter (A-Z)</li>
        <li>at least 1 lowercase letter (a-z)</li>
        <li>at least 1 number (0-9)</li>
        <li>at least 1 special character (@#$...)</li>
      </ul>
    </div>
  );
};

export const checkIconIfTrue = (value: any) => {
  if (value) {
    return (
      <FontAwesomeIcon icon={["fal", "check"]} style={{ color: "green" }} />
    );
  } else {
    return <FontAwesomeIcon icon={["fal", "times"]} style={{ color: "red" }} />;
  }
};

export const handleGlobalMessageAlert = (
  message: string | undefined,
  showMessage: boolean
) => {
  if (message && showMessage) {
    return (
      <Alert variant="success" className={genStyles["alenza__alert-success"]}>
        {message}
      </Alert>
    );
  } else {
    return null;
  }
};
